import { render, staticRenderFns } from "./AdminManager.vue?vue&type=template&id=487fa2dc&"
import script from "./AdminManager.vue?vue&type=script&lang=js&"
export * from "./AdminManager.vue?vue&type=script&lang=js&"
import style0 from "./AdminManager.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports